// extracted by mini-css-extract-plugin
export default {"content":"z6c1lG","contentBox":"x4BJUP","contentTitle":"ZM7awD","contentSubtitle":"HiyP6u","contentImg":"WuzpZL","contentV2":"GAtc3L"};